import { useLogger } from '@/composables/useLogger'
const { warn, logError } = useLogger()

export const toUTCString = () => {
  const now = new Date()
  return now.toISOString().replace('Z', '')
}

export const getCurrentUTCTimestamp = () => {
  return new Date().toISOString()
}

export const fromUTCToLocal = (utcString: string | Date) => {
  try {
    // Handle Date object input
    if (utcString instanceof Date) {
      const localDate = utcString
      const now = new Date()

      // If message is from today
      if (localDate.toLocaleDateString() === now.toLocaleDateString()) {
        return localDate
          .toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          })
          .toLowerCase()
      }

      // If message is from this year
      if (localDate.getFullYear() === now.getFullYear()) {
        return localDate
          .toLocaleDateString([], {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          })
          .toLowerCase()
      }

      // For older messages
      return localDate
        .toLocaleDateString([], {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        })
        .toLowerCase()
    }

    // Handle string input
    // Add Z suffix if missing to ensure proper UTC parsing
    const normalizedUTC = utcString.endsWith('Z') ? utcString : `${utcString}Z`
    const utcDate = new Date(normalizedUTC)
    const now = new Date()

    // Validate the date
    if (isNaN(utcDate.getTime())) {
      warn('Invalid date:', utcString)
      return ''
    }

    // Get local date directly from UTC string
    // This automatically handles timezone conversion
    const localDate = new Date(normalizedUTC)

    // If message is from today
    if (localDate.toLocaleDateString() === now.toLocaleDateString()) {
      return localDate
        .toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        })
        .toLowerCase()
    }

    // If message is from this year
    if (localDate.getFullYear() === now.getFullYear()) {
      return localDate
        .toLocaleDateString([], {
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        })
        .toLowerCase()
    }

    // For older messages
    return localDate
      .toLocaleDateString([], {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
      .toLowerCase()
  } catch (error) {
    logError('Error converting UTC to local:', error)
    return ''
  }
}

// Add alias for better naming consistency
export const toLocalString = fromUTCToLocal
